import React from 'react';
import { Badge, IconButton, Typography, useTheme } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useTranslation } from 'react-i18next';

interface AppBarNotificationProps {
  onNotificationClick?: any;
  unreadNotificationCount: number | undefined;
  label?: string;
}

export function AppBarNotification({
  onNotificationClick,
  unreadNotificationCount,
  label = '',
}: AppBarNotificationProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <IconButton
      data-testid="notifications"
      size="large"
      aria-label={t('accessibility.NOTIFICATIONS')}
      color="inherit"
      onClick={onNotificationClick}
    >
      <Badge badgeContent={unreadNotificationCount} color="error">
        <NotificationsIcon sx={{ fill: theme.palette.text.primary }} />
      </Badge>

      {label && (
        <Typography variant="subtitle1" sx={{ ml: 1 }}>
          {label}
        </Typography>
      )}
    </IconButton>
  );
}
